import ApiCrud from "./api-crud";

class ObraService extends ApiCrud {
  resource = "obras";
  primaryKey = "idobra";
}

export default new ObraService();
